import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";

type BackLinkProps = {
  children: string;
  to: string;
};

const Breadcrumb = styled(Link)`
  color: #fbba18;
  text-decoration: underline;
  margin-bottom: 20px;
`;

const StyledArrow = styled(FontAwesomeIcon)`
  margin-right: 5px;
`;
const BackLink: React.FC<BackLinkProps> = ({ children, to }) => {
  return (
    <Breadcrumb to={to}>
      <StyledArrow icon={faArrowLeft} size="sm" />
      {children}
    </Breadcrumb>
  );
};

export default BackLink;
